<template>
    <div class="report-cards">
        <v-row v-if="!showSelectClassroomDialog">
            <v-col cols="12" sm="12" md="12" lg="12" class="py-0">
                <v-card class="mx-4 mt-5 px-4" flat tile color="transparent">
                    <v-row>
                        <v-col cols="12" class="text-left pb-0">
                            <v-row>
                               <v-col cols="10">
                                    <h1>
                                        Classroom : {{ classroom.sections }}
                                    </h1>
                                    <h3>{{ classroom.session ? classroom.session.title : '' }}</h3>
                                </v-col> 
                            </v-row>
                        </v-col> 
                        <v-col cols="12" md="9">
                            <v-row>
                                <v-col cols="4" md="3">
                                    <h1 class="text-left">{{ classroom.room_no || "-" }}</h1>
                                    <p class="mb-0 text-left">Room number</p>
                                </v-col>
                                <v-col cols="4" md="3">
                                    <h1 class="text-left">{{ classroom.room_subjects }}</h1>
                                    <p class="mb-0 text-left">Subjects</p>
                                </v-col>
                                <v-col cols="4" md="3">
                                    <h1 class="text-left">{{ classroom.room_users }}</h1>
                                    <p class="mb-0 text-left">Students</p>
                                </v-col>
                            </v-row>
                            </v-col>   
                    </v-row>    
                </v-card>    
            </v-col>  

            <!-- All Subjects List -->
            <v-col cols="12" sm="12" md="12" lg="12">
                <v-container fluid class="ma-3">
                    <v-data-table
                        :headers="subjectHeaders"
                        :items="subjects"
                        :items-per-page="-1"
                        hide-default-footer
                    >
                        <template v-slot:item.code="{ item }">
                            <h4>{{ item.code || "-" }}</h4>
                        </template>
                        <template v-slot:item.name="{ item }">
                            <h4>{{ item.name }}</h4>
                        </template>
                        <template
                        v-slot:item.faculty="{ item }"
                        v-if="$vuetify.breakpoint.xs"
                        >
                            <div v-for="faculty in item.faculty" :key="faculty.id">
                                <p class="mb-0">{{ faculty.full_name }}</p>
                            </div>
                        </template>
                        <template v-slot:item.faculty="{ item }" v-else>{{
                        `${item.faculty.map((faculty) => " " + faculty.full_name)}`
                        }}</template>
                        <template v-slot:item.sheets="{ item }">
                            <v-file-input
                                ref="fileInput"
                                show-size
                                label="Upload excel file"
                                :rules="[rules.required]"
                                @change="excelCallback($event, item.name)"
                                clearable
                                @click:clear="clearFiles(item.name)"
                                :key="fileInputKey"          
                            >     
                            </v-file-input>
                        </template>
                    </v-data-table>
                </v-container>    
            </v-col>
            <!-- <v-col cols="12" md="3" justify="center">
                <v-btn
                    color="primary"
                    type="submit"
                    v-model="form"
                    :disabled="!checkSubmit"
                    @click="submitData()"
                >
                    Submit
                </v-btn>
            </v-col> -->
        </v-row>

       
        
        <v-dialog v-model="showSelectClassroomDialog" max-width="500px">
            <v-card>
                <v-form v-model="selectedClassRoom.valid" ref="selectedClassRoom">
                    <v-card-title>
                        <h4> Select Classroom </h4>
                    </v-card-title>   
                    <v-card-subtitle>
                        <p class="text-left mb-0">Select an academic year and classroom.</p>
                    </v-card-subtitle>
                    <v-card-text>
                        <v-container v-if="academicSessions">
                            <v-row>
                                <v-col col="12">
                                    <v-select
                                    v-model="selectedClassRoom.session"
                                    :items="academicSessions"
                                    item-text="title"
                                    item-value="id"
                                    outlined
                                    class="rounded-input"
                                    label="Academic Session"
                                    dense
                                    @change="selectedClassRoom.room = null"
                                    hide-details="auto"
                                    >
                                        <template v-slot:item="{ item }">
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    <span :class="item.active ? 'primary--text' : null ">{{ item.title }} {{ item.active ? ' ( Current )' : null }}</span>
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </template>
                                    </v-select>
                                </v-col>
                                <v-col cols="12">
                                    <v-select
                                        v-model="selectedClassRoom.room"
                                        v-if="selectedClassRoom.session"
                                        :items="academicSessions.find(session => session.id == selectedClassRoom.session).session_rooms"
                                        item-text="sections"
                                        item-value="id"
                                        outlined
                                        class="rounded-input"
                                        label="Classroom"
                                        dense
                                        @change="selectedClassRoom.valid = false"
                                        hide-details="auto"
                                    >
                                    </v-select>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>     
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary darken-1"
                            text
                            :disabled="selectedClassRoom.valid"
                            @click="displayClass"
                        >
                            Save
                        </v-btn>
                    </v-card-actions>                        
                </v-form>    
            </v-card>
        </v-dialog>

        <v-dialog v-model="checkSubmit" max-width="500px">
            <v-card>
                <v-card-title>
                    <h3 class="grey--text text--darken-2"> Generate report cards </h3>
                    <v-btn icon absolute top right color="dark" @click="checkSubmit = false">
						<b>x</b>
					</v-btn>
                </v-card-title>
                <v-card-subtitle>
                    <p class="text-left mb-0 mt-2">Select an action</p>
                </v-card-subtitle>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col col="12">
                                <v-btn
                                    type="submit"
                                    v-model="form"
                                    :disabled="generateReportButton"
                                    @click="submitData()"
                                >
                                    Upload sheets
                                </v-btn>
                            </v-col>
                        </v-row>
                        <!-- <v-row>
                            <v-col col="12">
                                <v-btn
                                    type="submit"
                                    v-model="form"
                                    :disabled="!generateReportButton"
                                    @click="generateReportCards()"
                                >
                                    Generate sheets
                                </v-btn>
                            </v-col>
                        </v-row> -->
                    </v-container>
                </v-card-text>

            </v-card>
        </v-dialog>

        <!-- snackbar -->
		<v-snackbar v-model="snackbar.visible" :color="snackbar.color" multi-line>
			{{ snackbar.message }}
			<template v-slot:action="{ attrs }">
				<v-btn dark text v-bind="attrs" @click="snackbar.visible = false">
					Close
				</v-btn>
			</template>
		</v-snackbar>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import api from "@api/index";
import endpoints from "@api/repository";
import Helper from "@utils/misc";
export default{
    name: "UploadAllSubjectsMarkSheet",

    // components: {
	// 	downloadExcel: JsonExcel,
	// },

    data() {
        return {
            checkSubmit: false,
            snackbar: {
				visible: false,
				message: "",
				color: "dark",
			},

            selectedClassRoom: {
                session: null,
                room: null,
                valid: false,
            },

            allFiles: {},
            generateReportButton: false,
            showSelectClassroomDialog: true,
            academicSessions: null,
            classroom: null,
            subjects: [],
            subjectHeaders: [
                { text: "Code", value: "code" },
                { text: "Subject Name", value: "name" },
                { text: "Assigned Teachers", value: "faculty", sortable: false },
                { text: "Prefilled Sheets", value:"sheets"},
            ],

            rules: {
				required: (value) => !!value || "Required",
			},

            export_in_progress: false,

            excelData: null,// store all import related data
			

        }
    },
    computed: {
    ...mapGetters(["accessToken", "currentUser", "isLoading","currentInstitution"]),
    apiEssentials() {
      return {
        accessToken: this.accessToken,
        handleErrorsFunction: this.handleApiErrors,
        setLoading: this.setLoading,
      };
    },
  }, 
    methods: {
        ...mapActions(["setLoading"]),
        async getAllAcademicSessions(){
            this.academicSessions = await api.call(this.apiEssentials, endpoints.academicSessionsViewSet)
        },
        async displayClass(){
            
            this.setLoading(true);
            this.getClassRoomDetails();
            this.getClassRoomSubjects();
            this.setLoading(false);
            this.showSelectClassroomDialog=false;
        },

        async getClassRoomDetails() {
            var response;
            var url = endpoints.getClassRoomDetails + `${this.selectedClassRoom.room}/`;

            response = await api.handleApi({
                apiEssentials: this.apiEssentials,
                url: url,
                responseVar: response,
            });
            if (response instanceof Error) {
                this.setLoading(false);
                this.snackbar.text = "Error retrieving details";
                this.snackbar.visible = true;
                return;
            } else {
                this.classroom = response;
            }
        },

        async getClassRoomSubjects() {
            
            var response;
            var url = endpoints.getClassRoomSubjects + `${this.selectedClassRoom.room}/`;

            response = await api.handleApi({
                apiEssentials: this.apiEssentials,
                url: url,
                responseVar: response,
            });

            if (response instanceof Error) {
                this.setLoading(false);
                this.snackbar.text = "Error retrieving subjects";
                this.snackbar.visible = true;
                return;
            } else {
                this.subjects = response;
            }
            // this.setLoading(false);
        },

        // catch the excel file from input and process
		async excelCallback(payload, subjectName) {
            const file = payload
			if(file) {
				this.excelFile = file
                var file_base64 = await Helper.toBase64(file);
                this.allFiles[subjectName] = file_base64;
                this.checkSubmitValidity();
			}
		},

        dataURItoBlob(dataURI) {
            const byteString = window.atob(dataURI);
            const arrayBuffer = new ArrayBuffer(byteString.length);
            const int8Array = new Uint8Array(arrayBuffer);
            for (let i = 0; i < byteString.length; i++) {
                int8Array[i] = byteString.charCodeAt(i);
            }
            const blob = new Blob([int8Array], { type: 'application/vnd.ms-excel' });
            return blob;
        },

        async submitData(){
            var url = endpoints.uploadAllSubjectSheet;
            var body = {
                room: this.selectedClassRoom.room,
                session: this.selectedClassRoom.session,
                fileData: this.allFiles,
                classRoom: this.classroom.sections,
                
            }
            var response = await api.call(
                this.apiEssentials,
                url,
                api.Methods.POST,
                body,
            );
            if(response){
                this.generateReportButton = true;
                this.snackbar.message = "Uploaded all sheets successfully";
				this.snackbar.color = "success";
				this.snackbar.visible = true;

                // debugger
                // var binarydata = [];
                // binarydata.push(response);
                // console.log(response);
                const blob = this.dataURItoBlob(response);
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = `report_cards.zip`;
                link.click();
            }
            return response;
        },

        clearFiles(subjectName){
            this.allFiles[subjectName] = null;
            this.checkSubmitValidity();
        },

        checkSubmitValidity(){
                var cnt = 0 ;
                var chk = 1;
                for(var key in this.allFiles){
                    cnt = cnt + 1;
                    if(this.allFiles[key] == null){
                        this.checkSubmit = false;
                        chk = 0;
                        break
                    }
                }
            
                this.checkSubmit = (cnt == this.subjects.length && chk == 1) ? true : false;            
        },
        
        async generateReportCards(){
            var url = endpoints.downloadAllReportCards;
            var response = await api.call(
                this.apiEssentials, 
                url,
                api.Methods.POST,
            );
            console.log(response);
        }

        
    },
    created() {
        this.getAllAcademicSessions();
    }
}
</script>
<style scoped>
.text-white {
  color: white !important;
}
.rounded-input {
  border-radius: 12px !important;
}
span.required::after {
  content: "*";
  font-size: 18px;
  color: red;
}
</style>